export const environment = {
    production: true,
    rootPath: '/api',
    domainPrefix: '',
    copyright: '© $YEAR$ Iren s.p.a.',
    address: 'Via Nubi di Magellano, 30 - 42123 Reggio Emilia \n Iren Mercato società appartenente al Gruppo IVA Iren con Partita IVA 02863660359 / Codice Fiscale 01178580997',
    forbiddenWords: ['admin', 'default', 'member', 'root', 'test', 'user']
};
